const TERMS_AND_PRIVACY_URLS = {
  TERMS_OF_USE: 'https://www.mismatch.gr/tos/',
  PRIVACY_POLICY: 'https://www.mismatch.gr/privacy-policy/',
}

export default TERMS_AND_PRIVACY_URLS
